import { BlackCross, CrossSvg } from "../../assets";
import { useTheme } from "../../context/ThemeProvider";

const ModalWrapper = ({ title, onClose, children, footer, showCloseButton = true, className }) => {
  const { theme } = useTheme();

  return (
    <div className={`max-w-[520px] max-h-[580px] w-full bg-surface-dialog rounded-2xl shadow-lg overflow-hidden flex flex-col ${className}`}>
      <div className="flex justify-between items-center p-6 border-b border-edge-border dark:border-edge-gray-700 flex-shrink-0">
        <h2 className="text-xl font-semibold text-ink-ink dark:text-ink-white">
          {title}
        </h2>
        {showCloseButton && (
          <button
            onClick={onClose}
            className="rounded-full p-2 transition-colors"
          >
            {theme === "dark" ? <CrossSvg className="w-[12px] h-[12px]" /> : <BlackCross className="w-[12px] h-[12px]" />}
          </button>
        )}
      </div>

      {children}
    </div>
  );
};

export default ModalWrapper;
